import { render, staticRenderFns } from "./StandingsPlayerDetailsPane.vue?vue&type=template&id=892b41b4&scoped=true"
import script from "./StandingsPlayerDetailsPane.vue?vue&type=script&lang=ts"
export * from "./StandingsPlayerDetailsPane.vue?vue&type=script&lang=ts"
import style0 from "./StandingsPlayerDetailsPane.vue?vue&type=style&index=0&id=892b41b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892b41b4",
  null
  
)

export default component.exports